import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import AnnouncementsFormComponent from './AnnouncementsFormComponent';
import AnnouncementsPreviewComponent from './AnnouncementsPreviewComponent';

const StyledPreviewContainer = styled(Box)(({ theme }) => ({
  width: '45%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '2rem 0 2rem 0',
  height: 'inherit',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const AnnouncementsModalComponent = (props) => {
  const { formValues } = props;
  const { subject: title, message } = formValues || {};

  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        sx={(theme) => ({
          width: '55%',
          [theme.breakpoints.down('sm')]: {
            width: '100%',
          },
        })}
      >
        <AnnouncementsFormComponent {...props} />
      </Box>
      <StyledPreviewContainer>
        <AnnouncementsPreviewComponent title={title} message={message} />
      </StyledPreviewContainer>
    </Box>
  );
};

AnnouncementsModalComponent.defaultProps = {
  formValues: null,
};

AnnouncementsModalComponent.propTypes = {
  formValues: PropTypes.instanceOf(Object),
};

export default AnnouncementsModalComponent;
